import {EditorToolType} from '@mc/react-mapio';
import {MeasurementInfo} from '../components/sidebar/content/MeasurementSidebar';

/**
 * Použití pro jednorázovou akci do dceřiných komponent.
 *
 * actionToTrigger: jaká činnost se má vykonat
 * tool: název nástroje který se má zobrazit/schovat
 * toolInfo: extra data pro nástroje. zatím používáno jen u measurement toolu
 *
 * přiklad užití:
 * Na klienta přijde z angularu event, že došlo k aktivaci měřítka.
 * S aktivací měřítka chci, aby se otevřelo i nové react měřítko.
 * Nastavím tedy trigger.actionToTrigger na SHOW a zanořím ho do komponenty,
 * která ma na starosti vykreslování nového měřítka.
 * V dané komponentě poté zkoumám, zda-li actionToTrigger není undefined (tzn. něco se má vykonat).
 * Pokud je nastaveno, implementuji switch na hodnoty actionToTrigger,
 * kde dělám co potřebuji (např. zobrazím komponentu měřítka).
 */
export type Trigger = {actionToTrigger: ETriggerAction; tool?: EditorToolType | string; toolInfo?: MeasurementInfo | any};

export enum ETriggerAction {
    NONE,
    HIDE,
    SHOW,
    BTN_TURN_ON,
    BTN_TURN_OFF,
}
